<template>
  <div>
    <catalogue-section v-for="(catalogue, company, index) in catalogues" :key="index" :catalogue-sections="catalogue" :catalogue-heading="company" :catalogue-index="index"/>
  </div>
</template>

<script>
import CatalogueSection from '../components/CatalogueSection.vue'

export default {
  components: { CatalogueSection },
  // eslint-disable-next-line
    name: 'Products',
    data(){
        return{
            catalogues : require("../assets/catalogue.json"),
        }
    },
}
</script>